import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import RTLLayout from 'layouts/rtl';
import AdminLayout from 'layouts/admin';
import AuthLayout from 'layouts/auth';
import PublicLayout from 'layouts/public';
import BackOfficeLayout from 'layouts/backoffice';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'assets/css/Plugins.css';
import GuessAccess from 'views/admin/guess';
import Impersonate from 'views/admin/impersonate';
import Manager from 'views/admin/manager';

const App = () => {
    return (
        <GoogleOAuthProvider clientId="447127369441-1153im5j42ag08bdm5k1jm40400j8bh1.apps.googleusercontent.com">
            <Routes>
                <Route path="auth/*" element={<AuthLayout />} />
                <Route path="admin/*" element={<AdminLayout />} />
                <Route path="back-office/*" element={<BackOfficeLayout />} />
                <Route path="rtl/*" element={<RTLLayout />} />
                <Route path="public/*" element={<PublicLayout />} />
                <Route path="/" element={<Navigate to="/admin" replace />} />
                <Route path="/guest/:id" element={<GuessAccess />} />
                <Route path="/impersonate" element={<Impersonate />} />
                <Route path="/manager" element={<Navigate to="/back-office" replace />} />
                <Route path="/manager/:id" element={<Manager />} />
            </Routes>
        </GoogleOAuthProvider>
    );
};

export default App;
